!(function (n, t) {
  "object" == typeof exports && "undefined" != typeof module
    ? (module.exports = t())
    : "function" == typeof define && define.amd
      ? define(t)
      : ((n =
          "undefined" != typeof globalThis
            ? globalThis
            : n || self).EmblaCarousel = t());
})(this, function () {
  "use strict";
  function n(n) {
    return (e) => n(t(e) ? e : e.get());
  }
  function t(n) {
    return "number" == typeof n;
  }
  function e(n) {
    return "string" == typeof n;
  }
  function r(n) {
    return "[object Object]" === Object.prototype.toString.call(n);
  }
  function o(n) {
    return Math.abs(n);
  }
  function i(n) {
    return Math.sign(n);
  }
  function s(n, t) {
    return o(n - t);
  }
  function c(n) {
    return d(n).map(Number);
  }
  function u(n) {
    return n[a(n)];
  }
  function a(n) {
    return Math.max(0, n.length - 1);
  }
  function f(n, t) {
    return t === a(n);
  }
  function l(n, t = 0) {
    return Array.from(Array(n - t + 1), (n, e) => t + e);
  }
  function d(n) {
    return Object.keys(n);
  }
  function p(n, t) {
    return [n, t].reduce(
      (n, t) => (
        d(t).forEach((e) => {
          const o = n[e],
            i = t[e],
            s = r(o) && r(i);
          n[e] = s ? p(o, i) : i;
        }),
        n
      ),
      {},
    );
  }
  function g(n, t) {
    return void 0 !== t.MouseEvent && n instanceof t.MouseEvent;
  }
  function m() {
    let n = [];
    const t = {
      add: function (e, r, o, i = { passive: !0 }) {
        let s;
        if ("addEventListener" in e)
          (e.addEventListener(r, o, i),
            (s = () => e.removeEventListener(r, o, i)));
        else {
          const n = e;
          (n.addListener(o), (s = () => n.removeListener(o)));
        }
        return (n.push(s), t);
      },
      clear: function () {
        n = n.filter((n) => n());
      },
    };
    return t;
  }
  function h(n, t) {
    const e = m(),
      r = 1e3 / 60;
    let o,
      i = null,
      s = 0,
      c = 0;
    function u(e) {
      if (!c) return;
      i || ((i = e), n(), n());
      const a = e - i;
      for (i = e, s += a; s >= r; ) (n(), (s -= r));
      (t(s / r), c && (c = o.requestAnimationFrame(u)));
    }
    function a() {
      c && (o.cancelAnimationFrame(c), (i = null), (s = 0), (c = 0));
    }
    return {
      init: function (n) {
        const t = n.document;
        ((o = n),
          e.add(t, "visibilitychange", () => {
            t.hidden && ((i = null), (s = 0));
          }));
      },
      destroy: function () {
        (a(), e.clear());
      },
      start: function () {
        c || (c = o.requestAnimationFrame(u));
      },
      stop: a,
      update: n,
      render: t,
    };
  }
  function v(t, e) {
    const r = "rtl" === e,
      o = "y" === t,
      i = !o && r ? -1 : 1;
    return {
      scroll: o ? "y" : "x",
      cross: o ? "x" : "y",
      startEdge: o ? "top" : r ? "right" : "left",
      endEdge: o ? "bottom" : r ? "left" : "right",
      nativeScroll: o ? "scrollTop" : "scrollLeft",
      getSize: function (n) {
        const { height: t, width: e } = n;
        return o ? t : e;
      },
      direction: n(function (n) {
        return n * i;
      }),
    };
  }
  function y(t = 0, e = 0) {
    const r = o(t - e);
    function i(n) {
      return n < t;
    }
    function s(n) {
      return n > e;
    }
    function c(n) {
      return i(n) || s(n);
    }
    return {
      length: r,
      max: e,
      min: t,
      clamp: n(function (n) {
        return c(n) ? (i(n) ? t : e) : n;
      }),
      pastAnyBound: n(c),
      pastMaxBound: n(s),
      pastMinBound: n(i),
      removeOffset: n(function (n) {
        return r ? n - r * Math.ceil((n - e) / r) : n;
      }),
    };
  }
  function x(n, t, e) {
    const { clamp: r } = y(0, n),
      i = n + 1;
    let s = c(t);
    function c(n) {
      return e ? o((i + n) % i) : r(n);
    }
    function u() {
      return s;
    }
    function a() {
      return x(n, u(), e);
    }
    const f = {
      get: u,
      set: function (n) {
        return ((s = c(n)), f);
      },
      add: function (n) {
        return a().set(u() + n);
      },
      clone: a,
    };
    return f;
  }
  function S(n, t, e, r, c, u, a, f, l, d, p, h, v, x, S, b, E) {
    const { cross: w, direction: L } = t,
      T = ["INPUT", "SELECT", "TEXTAREA"],
      D = { passive: !1 },
      M = m(),
      O = m(),
      z = y(50, 225).clamp(v.measure(20)),
      B = { mouse: 300, touch: 400 },
      A = { mouse: 500, touch: 600 },
      I = x ? 43 : 25;
    let P,
      k,
      F = !1,
      H = 0,
      V = 0,
      C = !1,
      $ = !1,
      j = !1,
      R = !1,
      N = !1;
    function G(n) {
      return d.byDistance(n, !x).distance;
    }
    function W(n) {
      const t = p.add(-1 * i(n));
      return x || o(n) < z
        ? G(n)
        : b && d.byDistance(0, !1).index !== p.get()
          ? 0.5 * G(n)
          : d.byIndex(t.get(), 0).distance;
    }
    function q(n) {
      if (!h.createEvent("pointerdown", n).emit()) return;
      const t = g(n, k),
        o = t && 0 !== n.button;
      ((N = t),
        (R = x && t && !n.buttons && F),
        (F = s(r.get(), u.get()) >= 2),
        o ||
          (function (n) {
            const t = n.nodeName || "";
            return T.includes(t);
          })(n.target) ||
          (($ = !0),
          c.pointerDown(n),
          l.useFriction(0).useDuration(0),
          r.set(u),
          (H = c.readPoint(n)),
          (V = c.readPoint(n, w)),
          (function () {
            const n = N ? P : e;
            O.add(n, "mousemove", U, D).add(n, "mouseup", Q);
          })(),
          (C = !0)));
    }
    function U(n) {
      if (!h.createEvent("pointermove", n).emit()) return Q(n);
      if (!g(n, k) && n.touches.length >= 2) return Q(n);
      const t = c.readPoint(n),
        e = c.readPoint(n, w),
        o = s(t, H),
        i = s(e, V);
      if (!j && !N) {
        if (!n.cancelable) return Q(n);
        if (((j = o > i), !j)) return Q(n);
      }
      const u = c.pointerMove(n);
      (o > S && (R = !0),
        l.useFriction(0.3).useDuration(0.75),
        a.start(),
        r.add(L(u)),
        n.cancelable && n.preventDefault());
    }
    function Q(n) {
      const t = h.createEvent("pointerup", n),
        e = c.pointerUp(n) * (x ? A : B)[N ? "mouse" : "touch"],
        r = W(L(e)),
        i = (function (n, t) {
          if (0 === n || 0 === t) return 0;
          if (o(n) <= o(t)) return 0;
          const e = s(o(n), o(t));
          return o(e / n);
        })(e, r),
        u = I - 10 * i,
        a = E + i / 50;
      ((j = !1),
        ($ = !1),
        (C = !1),
        (N = !1),
        O.clear(),
        l.useDuration(u).useFriction(a),
        f.distance(r, !x),
        t.emit());
    }
    function X(n) {
      R && (n.stopPropagation(), n.preventDefault(), (R = !1));
    }
    return {
      init: function (t) {
        if (!n) return;
        ((P = t.document), (k = t), c.init(t));
        const r = e;
        M.add(r, "dragstart", (n) => n.preventDefault(), D)
          .add(r, "touchmove", (n) => C && U(n), D)
          .add(r, "touchend", (n) => C && Q(n))
          .add(r, "touchstart", q)
          .add(r, "mousedown", q)
          .add(r, "touchcancel", Q)
          .add(r, "contextmenu", Q)
          .add(r, "click", X, !0);
      },
      destroy: function () {
        (M.clear(), O.clear(), (C = !1));
      },
      pointerDown: function () {
        return $;
      },
    };
  }
  function b(n) {
    let t, e, r;
    function i(n) {
      return n.timeStamp;
    }
    function s(e, r) {
      const o = "client" + ("x" === (r || n.scroll) ? "X" : "Y");
      return (g(e, t) ? e : e.touches[0])[o];
    }
    return {
      init: function (n) {
        t = n;
      },
      pointerDown: function (n) {
        return ((e = n), (r = n), s(n));
      },
      pointerMove: function (n) {
        const t = s(n) - s(r),
          o = i(n) - i(e) > 170;
        return ((r = n), o && (e = n), t);
      },
      pointerUp: function (n) {
        if (!e || !r) return 0;
        const t = s(r) - s(e),
          c = i(n) - i(e),
          u = i(n) - i(r) > 170,
          a = t / c;
        return c && !u && o(a) > 0.1 ? a : 0;
      },
      readPoint: s,
    };
  }
  function E(n, t, e, r, i, s) {
    const c = [t, ...r];
    let u,
      a,
      f = [],
      l = !1;
    function d(n) {
      return i.getSize(s.getRect(n));
    }
    function p(n) {
      const i = e.createEvent("resize", n);
      if (!!i.emit())
        for (const e of n) {
          if (l) return;
          const n = e.target === t,
            s = r.indexOf(e.target),
            c = n ? a : f[s];
          if (o(d(n ? t : r[s]) - c) >= 0.5) {
            i.api.reInit();
            break;
          }
        }
    }
    return {
      init: function (e) {
        n &&
          ((a = d(t)),
          (f = r.map(d)),
          (u = new e.ResizeObserver(p)),
          e.requestAnimationFrame(() => {
            c.forEach((n) => u.observe(n));
          }));
      },
      destroy: function () {
        ((l = !0), u && u.disconnect());
      },
    };
  }
  function w(n, t, e, r, i) {
    const { pastAnyBound: s, pastMinBound: c, clamp: u } = n,
      a = i.measure(10),
      f = i.measure(50),
      l = y(0.1, 0.99);
    let d = !1;
    function p() {
      return !d && !!s(e) && !!s(t);
    }
    return {
      shouldConstrain: p,
      constrain: function (i) {
        if (!p()) return;
        const s = c(t) ? "min" : "max",
          d = o(n[s] - t.get()),
          g = e.minus(t),
          m = l.clamp(d / f);
        (e.subtract(g * m),
          !i && o(g) < a && (e.set(u(e)), r.useDuration(25).useBaseFriction()));
      },
      toggleActive: function (n) {
        d = !n;
      },
    };
  }
  function L(n, t, e, r) {
    const o = t.min + 0.1,
      i = t.max + 0.1,
      { pastMinBound: s, pastMaxBound: c } = y(o, i);
    return {
      loop: function (t) {
        if (
          !(function (n) {
            return 1 === n ? c(e) : -1 === n && s(e);
          })(t)
        )
          return;
        const o = n * (-1 * t);
        r.forEach((n) => n.add(o));
      },
    };
  }
  function T(n, t, e, r, s) {
    const { pastAnyBound: c, removeOffset: a, clamp: f } = r;
    function l(n) {
      return n.sort((n, t) => o(n) - o(t))[0];
    }
    function d(t, r) {
      if (!n) return t;
      const o = [t, t + e, t - e];
      if (!r) return l(o);
      const s = o.filter((n) => i(n) === r);
      return s.length ? l(s) : u(o) - e;
    }
    return {
      byDistance: function (e, r) {
        const i = s.plus(e),
          { index: u, distance: l } = (function (e) {
            const r = n ? a(e) : f(e),
              { index: i } = t.reduce(
                (n, t, e) => {
                  const i = o(d(t - r, 0));
                  return i >= n.smallestDisplacement
                    ? n
                    : { smallestDisplacement: i, index: e };
                },
                { smallestDisplacement: 1 / 0, index: 0 },
              );
            return { index: i, distance: r };
          })(i),
          p = !n && c(i);
        return !r || p
          ? { index: u, distance: e }
          : { index: u, distance: e + d(t[u] - l, 0) };
      },
      byIndex: function (n, e) {
        return { index: n, distance: d(t[n] - s.get(), e) };
      },
      shortcut: d,
    };
  }
  function D(n, e, r, o, i, s, c) {
    function u(t) {
      const { index: i, distance: u } = t,
        a = e.get(),
        f = i !== a;
      if (
        (u &&
          (s.add(u),
          o.duration() ? n.start() : (n.update(), n.render(1), n.update())),
        f)
      ) {
        (r.set(a), e.set(i));
        c.createEvent("select", { targetSnap: i, sourceSnap: a }).emit();
      }
    }
    return {
      distance: function (n, t) {
        u(i.byDistance(n, t));
      },
      index: function (n, r) {
        const o = e.clone().set(n).get();
        u(
          i.byIndex(
            o,
            (function (n) {
              return n ? (t(n) ? n : "forward" === n ? -1 : 1) : 0;
            })(r),
          ),
        );
      },
    };
  }
  function M(n, e, r, o, i, s, c, u, a) {
    const f = { passive: !0, capture: !0 };
    let l = 0;
    function d(n) {
      "Tab" === n.code && (l = new Date().getTime());
    }
    return {
      init: function (p) {
        e &&
          (u.add(p.document, "keydown", d, !1),
          o.forEach((e, o) => {
            u.add(
              e,
              "focus",
              (e) =>
                (function (e, o) {
                  const u = new Date().getTime();
                  if (u - l > 10) return;
                  const f = a.createEvent("slidefocus", e);
                  if (!f.emit()) return;
                  r[n.nativeScroll] = 0;
                  const d = i.snapBySlide[o];
                  if (!t(d)) return;
                  (c.useDuration(0), s.index(d, 0));
                })(e, o),
              f,
            );
          }));
      },
    };
  }
  function O(t) {
    let e = t || 0;
    function r(n) {
      e += n;
    }
    function o(n) {
      return e + n;
    }
    return {
      get: function () {
        return e;
      },
      set: n(function (n) {
        e = n;
      }),
      add: n(r),
      subtract: n(function (n) {
        r(-n);
      }),
      plus: n(o),
      minus: n(function (n) {
        return o(-n);
      }),
    };
  }
  function z(n, t, e, r, o, i, s, u) {
    const a = 0.5,
      f = c(r),
      l = c(r).reverse(),
      d = (function () {
        const n = i[0];
        return m(g(l, n), t, !1);
      })().concat(
        (function () {
          const e = n - i[0] - 1;
          return m(g(f, e), -t, !0);
        })(),
      );
    function p(n, t) {
      return n.reduce((n, t) => n - r[t], t);
    }
    function g(n, t) {
      return n.reduce((n, e) => (p(n, t) > 0 ? [...n, e] : n), []);
    }
    function m(r, i, c) {
      const f = (function (t) {
        return o.map((r, o) => ({
          start: r - e[o] + a + t,
          end: r + n - a + t,
        }));
      })(i);
      return r.map((n) => {
        const e = c ? 0 : -t,
          r = c ? t : 0,
          o = c ? "end" : "start",
          i = f[n][o];
        return {
          index: n,
          loopPoint: i,
          slideLocation: O(-1),
          translate: u[n],
          target: () => (s.get() > i ? e : r),
        };
      });
    }
    return {
      canLoop: function () {
        return d.every(
          ({ index: t }) =>
            p(
              f.filter((n) => n !== t),
              n,
            ) <= 0.1,
        );
      },
      loop: function () {
        d.forEach((n) => {
          const { target: t, translate: e, slideLocation: r } = n,
            o = t();
          o !== r.get() && (e.to(o), r.set(o));
        });
      },
      loopPoints: d,
    };
  }
  function B(n, t, e) {
    let r,
      o = !1;
    function i(n) {
      const t = e.createEvent("slideschanged", n);
      if (!!t.emit())
        for (const e of n) {
          if (o) return;
          if ("childList" === e.type) {
            t.api.reInit();
            break;
          }
        }
    }
    return {
      init: function (e) {
        n && ((r = new e.MutationObserver(i)), r.observe(t, { childList: !0 }));
      },
      destroy: function () {
        (r && r.disconnect(), (o = !0));
      },
    };
  }
  function A(n, e, r, i, s, f, l, d, p) {
    const { startEdge: g, endEdge: m, direction: h } = n,
      v = t(r);
    return {
      groupSlides: function (n) {
        return v
          ? (function (n, t) {
              return c(n)
                .filter((n) => n % t == 0)
                .map((e) => n.slice(e, e + t));
            })(n, r)
          : (function (n) {
              return n.length
                ? c(n)
                    .reduce((t, r, c) => {
                      const v = u(t) || 0,
                        y = 0 === v,
                        x = r === a(n),
                        S = s[g] - f[v][g],
                        b = s[g] - f[r][m],
                        E = !i && y ? h(l) : 0,
                        w = o(b - (!i && x ? h(d) : 0) - (S + E));
                      return (
                        c && w > e + p && t.push(r),
                        x && t.push(n.length),
                        t
                      );
                    }, [])
                    .map((t, e, r) => {
                      const o = Math.max(r[e - 1] || 0);
                      return n.slice(o, t);
                    })
                : [];
            })(n);
      },
    };
  }
  function I(t, e, r = "px") {
    const o =
      "x" === t.scroll
        ? function (n) {
            return `translate3d(${n}${r},0px,0px)`;
          }
        : function (n) {
            return `translate3d(0px,${n}${r},0px)`;
          };
    let i = null,
      s = !1,
      c = !1;
    function u(n) {
      i !== n && ((i = n), (e.style.transform = n));
    }
    function a(n) {
      if (c) return;
      if (s === n) return;
      s = n;
      u(n ? o(0) : "");
    }
    return {
      set: u,
      clear: function () {
        (u(""), e.getAttribute("style") || e.removeAttribute("style"));
      },
      to: n(function (n) {
        if (c) return;
        s || a(!0);
        const e = (function (n) {
          return Math.round(100 * n) / 100;
        })(t.direction(n));
        u(o(e));
      }),
      get: n(o),
      toggleActive: function (n) {
        c = !n;
      },
      setIsScrolling: a,
    };
  }
  function P(n, t, e, r, o, i, s, c, u, a, l, d) {
    const p = -200,
      g = o ? [0, t, -t] : [0],
      m = r.reduce(
        (n, t, e) => Object.assign(Object.assign({}, n), { [e]: E(e, t) }),
        {},
      ),
      h = x(r.length - 1, 0, o);
    let v = u.get(),
      y = L(),
      S = y,
      b = [];
    function E(t, r) {
      return g.map((o) => ({ start: r - e[t] + p + o, end: r + n - p + o }));
    }
    function w(n, t, e, i) {
      const s = n.length > 0,
        c = s ? n[0] : t,
        u = h.clone().set(c),
        a = () => u.add(e).get();
      for (u.set(a()); u.get() !== c; ) {
        const t = u.get(),
          c = i(t);
        if (!c && s) break;
        c && n.push(t);
        const l = a();
        if ((u.set(l), o)) continue;
        const d = !l,
          p = f(r, l);
        if (d && -1 === e) break;
        if (p && 1 === e) break;
      }
    }
    function L() {
      const n = [],
        t = s.slidesBySnap[i.get()];
      if (!t) return n;
      if (!r.length) return n;
      const e = c.get(),
        o = u.get(),
        a = t[Math.floor(t.length / 2)],
        f = (function (n, t) {
          return (e) => m[e].some(({ start: e, end: r }) => e < n && r > t);
        })(Math.max(e, o), Math.min(e, o));
      return (f(a) && n.push(a), w(n, a, 1, f), w(n, a, -1, f), n);
    }
    function T(n) {
      ((y = L()),
        (b = (function (n, t) {
          const e = new Set(t);
          return n.filter((n) => !e.has(n));
        })(S, y)),
        (S = y),
        (v = n));
    }
    function D(n, t) {
      t.forEach((t) => {
        const e = a[t],
          r = l.loopPoints[t];
        (o && r ? r.target() : 0) || e.setIsScrolling(n);
      });
    }
    return {
      optimize: function (n) {
        const t = u.get();
        if (!n && t === v) return;
        (T(t),
          !d
            .createEvent("scrolloptimize", {
              slidesInView: y,
              slidesLeftView: b,
            })
            .emit() || (D(!0, y), D(!1, b)));
      },
    };
  }
  function k(t, r, d, p, g, k, F, H) {
    const {
        align: V,
        axis: C,
        direction: $,
        startSnap: j,
        loop: R,
        duration: N,
        dragFree: G,
        dragThreshold: W,
        inViewThreshold: q,
        inViewMargin: U,
        slidesToScroll: Q,
        skipSnaps: X,
        containScroll: Y,
        draggable: J,
        resize: K,
        slideChanges: Z,
        focus: _,
      } = p,
      nn = H ? 0 : 2,
      tn = v(C, $),
      { containerRect: en, slideRects: rn } = F,
      on = tn.getSize(en),
      sn = (function (n) {
        return {
          measure: function (t) {
            return n * (t / 100);
          },
        };
      })(on),
      cn = (function (n, t) {
        const r = {
          start: function () {
            return 0;
          },
          center: function (n) {
            return o(n) / 2;
          },
          end: o,
        };
        function o(n) {
          return t - n;
        }
        return {
          measure: function (o, i) {
            return e(n) ? r[n](o) : n(t, o, i);
          },
        };
      })(V, on),
      un = !R && !!Y,
      an = R || !!Y,
      {
        slideSizes: fn,
        slideSizesWithGaps: ln,
        startGap: dn,
        endGap: pn,
      } = (function (n, t, e, r, i, s) {
        const { ownerWindow: c } = s,
          { getSize: a, startEdge: l, endEdge: d } = n,
          p = e[0] && i && c,
          g = (function () {
            if (!p) return 0;
            const n = e[0];
            return o(t[l] - n[l]);
          })(),
          m = (function () {
            if (!p) return 0;
            const n = c.getComputedStyle(u(r));
            return parseFloat(n.getPropertyValue(`margin-${d}`));
          })(),
          h = e.map(a),
          v = e
            .map((n, t, e) => {
              const r = !t,
                o = f(e, t);
              return r ? h[t] + g : o ? h[t] + m : e[t + 1][l] - n[l];
            })
            .map(o);
        return { slideSizes: h, slideSizesWithGaps: v, startGap: g, endGap: m };
      })(tn, en, rn, d, an, g),
      gn = A(tn, on, Q, R, en, rn, dn, pn, nn),
      { snaps: mn, snapsAligned: hn } = (function (n, t, e, r, i) {
        const { startEdge: s, endEdge: c } = n,
          { groupSlides: a } = i,
          f = a(r)
            .map((n) => u(n)[c] - n[0][s])
            .map(o)
            .map(t.measure),
          l = r.map((n) => e[s] - n[s]).map((n) => -o(n)),
          d = a(l)
            .map((n) => n[0])
            .map((n, t) => n + f[t]);
        return { snaps: l, snapsAligned: d };
      })(tn, cn, en, rn, gn),
      vn = -u(mn) + u(ln),
      { snapsContained: yn, scrollContainLimit: xn } = (function (
        n,
        t,
        e,
        r,
        o,
      ) {
        const i = y(-t + n, 0),
          c = e
            .map((n, t) => {
              const { min: r, max: o } = i,
                s = i.clamp(n),
                c = !t,
                u = f(e, t);
              return c ? o : u || l(r, s) ? r : l(o, s) ? o : s;
            })
            .map((n) => parseFloat(n.toFixed(3))),
          a = (function () {
            const n = c[0],
              t = u(c);
            return y(c.lastIndexOf(n), c.indexOf(t) + 1);
          })();
        function l(n, t) {
          return !!o && s(n, t) <= 1;
        }
        return {
          snapsContained: (function () {
            if (t <= n + o) return [i.max];
            if ("keepSnaps" === r) return c;
            const { min: e, max: s } = a;
            return c.slice(e, s);
          })(),
          scrollContainLimit: a,
        };
      })(on, vn, hn, Y, nn),
      Sn = un ? yn : hn,
      { limit: bn } = (function (n, t, e) {
        const r = t[0];
        return { limit: y(e ? r - n : u(t), r) };
      })(vn, Sn, R),
      En = x(a(Sn), j, R),
      wn = En.clone(),
      Ln = c(d),
      Tn = {
        update: function (n) {
          const {
            dragHandler: t,
            scrollBody: e,
            scrollBounds: r,
            options: { loop: o },
          } = n;
          (o || r.constrain(t.pointerDown()), e.seek());
        },
        render: function (n, t) {
          const {
              scrollBody: e,
              translate: r,
              location: o,
              offsetLocation: i,
              previousLocation: s,
              scrollLooper: c,
              slideLooper: u,
              dragHandler: a,
              animation: f,
              eventHandler: l,
              scrollBounds: d,
              scrollOptimizer: p,
              options: { loop: g },
            } = n,
            m = e.settled(),
            h = !d.shouldConstrain(),
            v = a.pointerDown(),
            y = m && (g || h),
            x = !y,
            S = x && v,
            b = y && !v;
          b && (p.optimize(b), f.stop());
          const E = o.get() * t + s.get() * (1 - t);
          (i.set(E),
            g && (c.loop(e.direction()), u.loop()),
            r.to(i),
            p.optimize(),
            b && l.createEvent("settle", null).emit(),
            x && l.createEvent("scroll", { isDragging: S }).emit());
        },
      },
      Dn = h(
        () => Tn.update(Wn),
        (n) => Tn.render(Wn, n),
      ),
      Mn = Sn[En.get()],
      On = O(Mn),
      zn = O(Mn),
      Bn = O(Mn),
      An = O(Mn),
      In = I(tn, r),
      Pn = d.map((n) => I(tn, n)),
      kn = (function (t) {
        const { max: e, length: r } = t;
        return {
          get: n(function (n) {
            return r ? (n - e) / -r : 0;
          }),
        };
      })(bn),
      Fn = (function (n, t, e, r, s, c) {
        let u = 0,
          a = 0,
          f = s,
          l = c,
          d = n.get(),
          p = 0;
        function g(n) {
          return ((f = n), h);
        }
        function m(n) {
          return ((l = n), h);
        }
        const h = {
          direction: function () {
            return a;
          },
          duration: function () {
            return f;
          },
          velocity: function () {
            return u;
          },
          seek: function () {
            const t = r.minus(n);
            let o = 0;
            return (
              f
                ? (e.set(n),
                  (u += t / f),
                  (u *= l),
                  (d += u),
                  n.add(u),
                  (o = d - p))
                : ((u = 0), e.set(r), n.set(r), (o = t)),
              (a = i(o)),
              (p = d),
              h
            );
          },
          settled: function () {
            return o(r.minus(t)) < 0.001;
          },
          useBaseFriction: function () {
            return m(c);
          },
          useBaseDuration: function () {
            return g(s);
          },
          useFriction: m,
          useDuration: g,
        };
        return h;
      })(On, Bn, zn, An, N, 0.68),
      Hn = (function (n, t, e, r, o, i, s) {
        const { groupSlides: c } = o,
          { min: d, max: p } = r,
          g = (function () {
            const r = c(i),
              o = !n || "keepSnaps" === t;
            return 1 === e.length
              ? [i]
              : o
                ? r
                : r.slice(d, p).map((n, t, e) => {
                    const r = !t,
                      o = f(e, t);
                    return r ? l(u(n)) : o ? l(a(i), n[0]) : n;
                  });
          })(),
          m = (function () {
            const n = {};
            return (
              g.forEach((t, e) => {
                t.forEach((t) => {
                  n[t] = e;
                });
              }),
              n
            );
          })(),
          h = e.map(s.get),
          v = e.length;
        return {
          slidesBySnap: g,
          snapBySlide: m,
          progressBySnap: h,
          length: v,
        };
      })(un, Y, Sn, xn, gn, Ln, kn),
      Vn = z(on, vn, fn, ln, mn, Sn, Bn, Pn),
      Cn = P(on, vn, ln, mn, R, En, Hn, Bn, An, Pn, Vn, k),
      $n = T(R, Sn, vn, bn, An),
      jn = D(Dn, En, wn, Fn, $n, An, k),
      Rn = m(),
      Nn = (function (n, t, e, r, o) {
        const i = new Set();
        let s,
          c = !1;
        function u(n) {
          const r = [],
            o = [];
          for (const e of n) {
            if (c) return;
            const n = t.indexOf(e.target);
            e.isIntersecting ? (i.add(n), r.push(n)) : (i.delete(n), o.push(n));
          }
          e.createEvent("slidesinview", {
            slidesInView: a(),
            slidesLeftView: o,
            slidesEnterView: r,
          }).emit();
        }
        function a() {
          return [...i];
        }
        return {
          init: function (e) {
            ((s = new e.IntersectionObserver(u, {
              root: n.parentElement,
              threshold: r,
              rootMargin: o,
            })),
              t.forEach((n) => s.observe(n)));
          },
          destroy: function () {
            (s && s.disconnect(), (c = !0));
          },
          get: a,
        };
      })(r, d, k, q, U),
      Gn = M(tn, _, t, d, Hn, jn, Fn, Rn, k),
      Wn = {
        eventHandler: k,
        containerRect: en,
        contentSize: vn,
        slideRects: rn,
        nodeHandler: g,
        animation: Dn,
        slideSizes: fn,
        isSsr: H,
        axis: tn,
        dragHandler: S(
          J,
          tn,
          t,
          An,
          b(tn),
          On,
          Dn,
          jn,
          Fn,
          $n,
          En,
          k,
          sn,
          G,
          W,
          X,
          0.68,
        ),
        eventStore: Rn,
        percentOfView: sn,
        indexCurrent: En,
        indexPrevious: wn,
        limit: bn,
        location: On,
        offsetLocation: Bn,
        previousLocation: zn,
        options: p,
        resizeHandler: E(K, r, k, d, tn, g),
        scrollBody: Fn,
        scrollBounds: w(bn, Bn, An, Fn, sn),
        scrollLooper: L(vn, bn, Bn, [On, Bn, zn, An]),
        scrollProgress: kn,
        scrollSnaps: Sn,
        scrollTarget: $n,
        scrollTo: jn,
        slideLooper: Vn,
        slideFocus: Gn,
        slidesHandler: B(Z, r, k),
        slidesInView: Nn,
        slideIndexes: Ln,
        slidesToScroll: gn,
        slideTranslates: Pn,
        scrollSnapList: Hn,
        scrollOptimizer: Cn,
        translate: In,
        target: An,
      };
    return Wn;
  }
  function F() {
    let n,
      t = {};
    function e(n) {
      return t[n] || [];
    }
    function r(n, r) {
      return ((t = Object.assign(Object.assign({}, t), { [n]: r(e(n)) })), o);
    }
    const o = {
      init: function (t) {
        n = t;
      },
      clear: function () {
        t = {};
      },
      createEvent: function (t, r) {
        return {
          api: n,
          emit: () =>
            (function (t, r) {
              const o = (function (t, e) {
                return { api: n, type: t, detail: e };
              })(t, r);
              return e(t).every((t) => !1 !== t(n, o));
            })(t, r),
        };
      },
      on: function (n, t) {
        return (r(n, (n) => (n.includes(t) ? n : [...n, t])), o);
      },
      off: function (n, t) {
        return (r(n, (n) => n.filter((n) => n !== t)), o);
      },
    };
    return o;
  }
  const H = {
    align: "center",
    axis: "x",
    container: null,
    slides: null,
    containScroll: "trimSnaps",
    direction: "ltr",
    slidesToScroll: 1,
    inViewThreshold: 0,
    inViewMargin: "0px",
    breakpoints: {},
    dragFree: !1,
    dragThreshold: 10,
    loop: !1,
    skipSnaps: !1,
    duration: 25,
    startSnap: 0,
    active: !0,
    draggable: !0,
    resize: !0,
    focus: !0,
    slideChanges: !0,
    ssr: [],
  };
  function V(n) {
    const t = n ? n.ownerDocument : null;
    let r;
    function o(n) {
      const {
        offsetTop: t,
        offsetLeft: e,
        offsetWidth: r,
        offsetHeight: o,
      } = n;
      return {
        top: t,
        right: e + r,
        bottom: t + o,
        left: e,
        width: r,
        height: o,
      };
    }
    function i(n, t, e, r) {
      return { offsetLeft: n, offsetTop: t, offsetWidth: e, offsetHeight: r };
    }
    return {
      ownerDocument: t,
      ownerWindow: t ? t.defaultView : null,
      getNodes: function (t) {
        return n
          ? (function (t) {
              const { container: r, slides: o } = t,
                i = (e(r) ? n.querySelector(r) : r) || n.children[0],
                s = e(o) ? i.querySelectorAll(o) : o,
                c = Array.from(s || i.children);
              return { root: n, container: i, slides: c };
            })(t)
          : (function (n) {
              const t = i(0, 0, 100, 100);
              let e = 0;
              return {
                root: t,
                container: t,
                slides: n.ssr.map((n) => {
                  const t = i(e, e, n, n);
                  return ((e += n), t);
                }),
              };
            })(t);
      },
      getRect: o,
      getRects: function (t, e, i) {
        if (i && r) return r;
        const s = n ? t.style : { transform: "" },
          c = s.transform;
        s.transform = "none";
        const u = o(t),
          a = e.map(o);
        return (
          (s.transform = c),
          (r = { containerRect: u, slideRects: a }),
          r
        );
      },
    };
  }
  function C() {
    let n;
    function t(n, t) {
      return p(n, t || {});
    }
    const e = {
      init: function (t) {
        t && (n = t);
      },
      mergeOptions: t,
      optionsAtMedia: function (e) {
        if (!n) return e;
        const r = e.breakpoints || {},
          o = d(r)
            .filter((t) => n.matchMedia(t).matches)
            .map((n) => r[n])
            .reduce((n, e) => t(n, e), {});
        return t(e, o);
      },
      optionsMediaQueries: function (t) {
        return n
          ? t
              .map((n) => d(n.breakpoints || {}))
              .reduce((n, t) => n.concat(t), [])
              .map(n.matchMedia)
          : [];
      },
    };
    return e;
  }
  function $(n, t, e) {
    const r = !n,
      o = C(),
      s = (function (n) {
        let t = [];
        return {
          init: function (e, r) {
            return (
              (t = r),
              r.reduce(
                (t, r) => (
                  r.init(e, n),
                  Object.assign(Object.assign({}, t), { [r.name]: r })
                ),
                {},
              )
            );
          },
          destroy: function () {
            t = t.filter((n) => n.destroy());
          },
        };
      })(o),
      c = m(),
      u = F(),
      { mergeOptions: a, optionsAtMedia: f, optionsMediaQueries: l } = o,
      { on: d, off: p, createEvent: g } = u,
      h = A;
    let y,
      x,
      S,
      b,
      E,
      w,
      L = !1,
      T = a(H, $.globalOptions),
      D = a(T),
      M = [],
      O = {};
    function z(n, t, e, o) {
      const i = a(n, r ? { direction: "ltr" } : {}),
        s = x.getRects(t, e, o),
        c = k(b, t, e, i, x, u, s, r);
      if (n.loop && !c.slideLooper.canLoop()) {
        return z(a(n, { loop: !1 }), t, e, !0);
      }
      return c;
    }
    function B(t, e) {
      if (L) return;
      x = V(n);
      const { ownerWindow: u } = x;
      (o.init(u), (T = a(T, t)), (D = f(T)), (M = e || M));
      const d = x.getNodes(D);
      ((b = d.root),
        (E = d.container),
        (w = d.slides),
        (y = z(D, E, w)),
        (S = (function (n, t, e, r, o, s) {
          const c = I(t, n, "%");
          function u(n, t, r) {
            const { direction: o } = v(n.axis, n.direction),
              { slides: u, container: a } = e.getNodes(n),
              { location: f, slideLooper: l, contentSize: d } = s(n, a, u),
              p = n.loop ? l.loopPoints : [],
              g = o(f),
              m = c.get(g);
            return (
              `${t}{transform:${m};}` +
              p.reduce((e, s) => {
                const { index: u } = s,
                  a = i(s.target()),
                  f = n.ssr[u];
                if (!a || !f) return e;
                const l = o((d / f) * 100 * a),
                  p = c.get(l);
                return e + `${t} ${r}:nth-child(${u + 1}){transform:${p};}`;
              }, "")
            );
          }
          return {
            getStyles: function (n, t = "> *") {
              if (!r.ssr.length) return "";
              const e = r.breakpoints || {};
              return (
                u(r, n, t) +
                Object.keys(e).reduce(
                  (i, s) => i + `@media ${s}{${u(o(r, e[s]), n, t)}}`,
                  "",
                )
              );
            },
          };
        })(E, y.axis, x, T, a, z)),
        l([T, ...M.map(({ options: n }) => n)]).forEach((n) =>
          c.add(n, "change", A),
        ),
        D.active &&
          (!r &&
            u &&
            (y.translate.to(y.location),
            y.scrollOptimizer.optimize(!0),
            y.options.loop && y.slideLooper.loop(),
            y.animation.init(u),
            y.resizeHandler.init(u),
            y.slidesInView.init(u),
            y.slidesHandler.init(u),
            y.slideFocus.init(u),
            y.eventHandler.init(G),
            E.offsetParent && w.length && y.dragHandler.init(u)),
          (O = s.init(G, M))));
    }
    function A(n, t) {
      const e = u.createEvent("reinit", null),
        r = N();
      (P(), B(a({ startSnap: r }, n), t), e.emit());
    }
    function P() {
      (y.dragHandler.destroy(),
        y.resizeHandler.destroy(),
        y.slidesHandler.destroy(),
        y.slidesInView.destroy(),
        y.animation.destroy(),
        s.destroy(),
        y.eventStore.clear(),
        c.clear(),
        y.translate.clear(),
        y.slideTranslates.forEach((n) => n.clear()));
    }
    function j(n, t, e) {
      L ||
        r ||
        (D.active &&
          (y.scrollBody
            .useBaseFriction()
            .useDuration(!0 === t ? 0 : D.duration),
          y.scrollTo.index(n, e)));
    }
    function R(n) {
      return y.indexCurrent.add(n).get();
    }
    function N() {
      return R(0);
    }
    const G = {
      canGoToNext: function () {
        return R(1) !== N();
      },
      canGoToPrev: function () {
        return R(-1) !== N();
      },
      cloneEngine: function (n) {
        return z(a(D, n), E, w, !0);
      },
      containerNode: function () {
        return E;
      },
      createEvent: g,
      internalEngine: function () {
        return y;
      },
      destroy: function () {
        if (L) return;
        if (r) return;
        const n = u.createEvent("destroy", null);
        ((L = !0), c.clear(), P(), n.emit(), u.clear());
      },
      on: d,
      off: p,
      plugins: function () {
        return O;
      },
      previousSnap: function () {
        return y.indexPrevious.get();
      },
      reInit: h,
      rootNode: function () {
        return b;
      },
      goToNext: function (n) {
        j(R(1), n, -1);
      },
      goToPrev: function (n) {
        j(R(-1), n, 1);
      },
      scrollProgress: function () {
        return y.scrollProgress.get(y.offsetLocation);
      },
      goTo: j,
      selectedSnap: N,
      slideNodes: function () {
        return w;
      },
      slidesInView: function () {
        return y.slidesInView.get();
      },
      snapIndex: R,
      snapList: function () {
        return y.scrollSnapList.progressBySnap;
      },
      ssrStyles: function (n, t) {
        return r ? S.getStyles(n, t) : "";
      },
    };
    return (B(t || {}, e || []), G);
  }
  return (($.globalOptions = void 0), $);
});
